import { atom } from 'recoil'

export const step4State = atom({
  key: 'workflowStep4State',
  default: {
    Group: [],
    Filter: [],
    FiltersRule: 'AND',
    StartHour: null,
    BlackoutStartHour: null,
    BlackoutEndHour: null,
    TimeZoneCode: undefined,
    StartDate: null,
    EndDate: null,
    FrequencyBlackoutDate: [],
    NotInWeekends: false,
    FrequencySafeGuard: 0
  }
})
